var React = require('react');

function Book (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.065 3.307a8.608 8.608 0 00-4.694-.37 8.397 8.397 0 00-4.146 2.146 8.122 8.122 0 00-4.26-2.184 8.32 8.32 0 00-4.797.563.865.865 0 00-.533.785V17.26c-.001.257.13.5.35.648.221.147.503.182.755.092a8.304 8.304 0 017.27.869c.364.238.795.364 1.236.363.43 0 .85-.121 1.21-.35a8.574 8.574 0 017.128-.974.833.833 0 00.245.035c.453-.003.817-.357.816-.792V4.108a.865.865 0 00-.58-.801zM9.952 7.363v8.853a10.8 10.8 0 00-5.94-.862V5.239a5.874 5.874 0 012.962 0 5.69 5.69 0 012.554 1.44c.163.188.305.391.424.606v.078z","fill":"#4541E3"}));
}

Book.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = Book;

Book.default = Book;
